import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Estado en vivo del bloqueo/suspensión de la empresa del usuario.
 *
 * La verdad vive en el backend (BookingV2 lee public.blocks y responde 423 en
 * las rutas del cliente cuando la empresa está apagada). Aquí solo reflejamos
 * lo que llega en ese 423 para pintar la pantalla de suspensión. NO se persiste:
 * es reversible: al resolver el bloqueo en el backoffice, el siguiente
 * /api/user responde 200 y limpiamos este estado (useAuth).
 */
export type CompanyBlockStatus = 'suspendida' | 'bloqueada'

export const useCompanyBlockStore = defineStore('companyBlock', () => {
	const blocked = ref(false)
	const status = ref<CompanyBlockStatus | string>()
	const reason = ref<string>()

	const set = (payload: { status?: string; reason?: string }) => {
		blocked.value = true
		status.value = payload.status
		reason.value = payload.reason
	}

	const reset = () => {
		blocked.value = false
		status.value = undefined
		reason.value = undefined
	}

	return { blocked, status, reason, set, reset }
})
